import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "flex-grow"
}, null, -1);
const _hoisted_2 = {
  class: "mr-6 flex flex-col justify-center cursor-pointer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_router_link = _resolveComponent("router-link");
  const _component_el_menu = _resolveComponent("el-menu");
  const _component_el_affix = _resolveComponent("el-affix");
  return _openBlock(), _createBlock(_component_el_affix, {
    offset: 0
  }, {
    default: _withCtx(() => [_createElementVNode("nav", null, [_createVNode(_component_el_menu, {
      "default-active": _ctx.activeIndex,
      class: "el-menu-demo",
      mode: "horizontal",
      ellipsis: false
    }, {
      default: _withCtx(() => [_createVNode(_component_el_menu_item, {
        index: "0"
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          src: "/image/icon/logo-black.png",
          alt: "logo",
          class: "h-14",
          onClick: _cache[0] || (_cache[0] =
          //@ts-ignore
          (...args) => _ctx.goHome && _ctx.goHome(...args))
        })]),
        _: 1
      }), _hoisted_1, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerMenu, (topMenu, topIndex) => {
        return _openBlock(), _createElementBlock("div", {
          key: `top${topIndex}`
        }, [_createVNode(_component_el_menu_item, {
          index: `${topIndex + 1}`
        }, {
          default: _withCtx(() => [_createVNode(_component_router_link, {
            to: topMenu === 'home' ? '/' : `/${topMenu}`
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t(`menu.${topMenu}`)), 1)]),
            _: 2
          }, 1032, ["to"])]),
          _: 2
        }, 1032, ["index"])]);
      }), 128)), _createElementVNode("div", _hoisted_2, [_createElementVNode("span", {
        class: _normalizeClass(`icon iconfont ${_ctx.currentLanguage === 'en' ? 'icon-zhongyingwen' : 'icon-zhongyingwen2zhongwen'}`),
        onClick: _cache[1] || (_cache[1] = $event => _ctx.setLanguage())
      }, null, 2)])]),
      _: 1
    }, 8, ["default-active"])])]),
    _: 1
  });
}